module.exports = __webpack_public_path__ + "static/media/meter-electricity.44fda2a6.svg";